import { createAction } from 'redux-act';
import { createAsyncAction } from "./utils";
export var getBillers = createAsyncAction('getBillers', function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$serverRequest = _ref.serverRequest,
      serverRequest = _ref$serverRequest === void 0 ? false : _ref$serverRequest,
      _ref$clientId = _ref.clientId,
      clientId = _ref$clientId === void 0 ? 'my-nerdwallet' : _ref$clientId;

  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.BillsServicesSDK.getBillers({
        client_id: clientId
      }, serverRequest);
    }
  };
});
export var getSavingsEstimate = createAsyncAction('getSavingsEstimate', function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$serverRequest = _ref2.serverRequest,
      serverRequest = _ref2$serverRequest === void 0 ? false : _ref2$serverRequest,
      _ref2$clientId = _ref2.clientId,
      clientId = _ref2$clientId === void 0 ? 'my-nerdwallet' : _ref2$clientId,
      _ref2$billerId = _ref2.billerId,
      billerId = _ref2$billerId === void 0 ? null : _ref2$billerId,
      _ref2$billAmount = _ref2.billAmount,
      billAmount = _ref2$billAmount === void 0 ? 0 : _ref2$billAmount;

  return {
    makeRequest: function makeRequest(state, opts) {
      var params = {
        client_id: clientId,
        biller_id: billerId,
        bill_amount: billAmount
      };
      return opts.BillsServicesSDK.getSavingsEstimate(params, serverRequest);
    }
  };
});
export var resetSavingsEstimate = createAction('resetSavingsEstimate');
export var createBillsharkAccount = createAsyncAction('createBillsharkAccount', function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$serverRequest = _ref3.serverRequest,
      serverRequest = _ref3$serverRequest === void 0 ? false : _ref3$serverRequest,
      _ref3$clientId = _ref3.clientId,
      clientId = _ref3$clientId === void 0 ? 'my-nerdwallet' : _ref3$clientId,
      firstName = _ref3.firstName,
      lastName = _ref3.lastName,
      email = _ref3.email,
      phoneNumber = _ref3.phoneNumber,
      billPhoneNumber = _ref3.billPhoneNumber,
      dateOfBirth = _ref3.dateOfBirth,
      addressLineOne = _ref3.addressLineOne,
      addressLineTwo = _ref3.addressLineTwo,
      city = _ref3.city,
      addressState = _ref3.addressState,
      postalCode = _ref3.postalCode,
      lastFourSSN = _ref3.lastFourSSN,
      billerId = _ref3.billerId,
      billAmount = _ref3.billAmount,
      billPin = _ref3.billPin;

  return {
    makeRequest: function makeRequest(state, opts) {
      var params = {
        client_id: clientId,
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone_number: phoneNumber,
        bill_phone_number: billPhoneNumber,
        date_of_birth: dateOfBirth,
        address_line_one: addressLineOne,
        address_line_two: addressLineTwo,
        city: city,
        state: addressState,
        postal_code: postalCode,
        last_four_ssn: lastFourSSN,
        biller_id: billerId,
        bill_amount: billAmount,
        bill_pin: billPin
      };
      return opts.BillsServicesSDK.createAccount(params, serverRequest);
    },
    meta: {
      city: city,
      addressState: addressState,
      postalCode: postalCode
    }
  };
});
export var getBills = createAsyncAction('getBills', function () {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$serverRequest = _ref4.serverRequest,
      serverRequest = _ref4$serverRequest === void 0 ? false : _ref4$serverRequest,
      _ref4$clientId = _ref4.clientId,
      clientId = _ref4$clientId === void 0 ? 'my-nerdwallet' : _ref4$clientId;

  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.BillsServicesSDK.getBills({
        client_id: clientId
      }, serverRequest);
    }
  };
});